import { GAME_KEYS } from "../store/game/game.constants"
import { ROUTER_NAMES } from "@/constants/router.constants"

const COURSE_SUPPORTED_GAMES = [
  GAME_KEYS.APEX_LEGENDS,
  GAME_KEYS.COD_COLD_WAR,
  GAME_KEYS.CSGO,
  GAME_KEYS.FORTNITE,
  GAME_KEYS.HEARTHSTONE,
  GAME_KEYS.LEAGUE_OF_LEGENDS,
  GAME_KEYS.MTG,
  GAME_KEYS.OVERWATCH,
  GAME_KEYS.ROCKET_LEAGUE,
  GAME_KEYS.SSBU,
  GAME_KEYS.VALORANT,
]

const GAME_CUSTOM_NAV_LINK_ITEMS = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: [
    {
      name: "CHAMPIONS",
      route: {
        name: ROUTER_NAMES.LOL_CHAMPIONS,
      },
    },
  ],
  [GAME_KEYS.SSBU]: [
    {
      name: "CHARACTER TIER LIST",
      route: {
        name: ROUTER_NAMES.SSBU_TIER_LIST,
      },
    },
  ],
}

let navLinks = {}
Object.values(GAME_KEYS).forEach(gameKey => {
  const navLinkItems = []

  // Include Dashboard for all games
  navLinkItems.push({
    name: "DASHBOARD",
    route: {
      name: ROUTER_NAMES.DASHBOARD,
      params: {
        game: gameKey,
      },
    },
  })

  // Check if game supports Courses
  if (COURSE_SUPPORTED_GAMES.includes(gameKey)) {
    navLinkItems.push({
      name: "COURSES",
      route: {
        name: ROUTER_NAMES.COURSES_PAGE,
        params: {
          game: gameKey,
        },
      },
    })
  }

  // Check if a game has any custom pages
  if (gameKey in GAME_CUSTOM_NAV_LINK_ITEMS) {
    navLinkItems.push(...GAME_CUSTOM_NAV_LINK_ITEMS[gameKey])
  }

  // Include Bootcamps for all games
  navLinkItems.push({
    name: "BOOTCAMPS",
    route: {
      name: ROUTER_NAMES.BOOTCAMPS,
    },
  })

  navLinkItems.push({
    name: "GUIDES",
    route: '/guides',
    external: true,
    new: true,
  })

  navLinks[gameKey] = navLinkItems
})

export const NAV_LINKS = navLinks



// WEBPACK FOOTER //
// ./src/constants/navbar.js